module.exports = __webpack_public_path__ + "static/media/car2.e6608c17.jpg";